import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import React from "react";
import cx from "classnames";
import useMeasure from "react-use-measure";
import { useDynamicStyles } from "./hooks/useDynamicStyles";
import { useQuickViewInternal } from "./QuickViewProvider";
import styles from "./QuickView.module.css";
export var QuickViewOverlay = function (_ref) {
  var show = _ref.show,
    onClose = _ref.onClose,
    closeOnOverlayClick = _ref.closeOnOverlayClick,
    overlayClassName = _ref.overlayClassName,
    _useMeasure = useMeasure({
      scroll: !0
    }),
    _useMeasure2 = _slicedToArray(_useMeasure, 2),
    measureContainer = _useMeasure2[0],
    containerBounds = _useMeasure2[1];
  measureContainer(useQuickViewInternal().containerRef.current);
  var _useDynamicStyles = useDynamicStyles(containerBounds),
    right = _useDynamicStyles.right,
    width = _useDynamicStyles.width,
    totalHeight = _useDynamicStyles.totalHeight;
  return React.createElement("div", {
    id: "quick-view-overlay",
    className: cx(styles.quickViewOverlay, _defineProperty({}, styles.quickViewOverlayHidden, !show), overlayClassName),
    style: {
      right: right,
      width: width,
      height: totalHeight
    },
    onClick: function (evt) {
      closeOnOverlayClick && (evt.preventDefault(), evt.stopPropagation(), onClose());
    },
    role: "presentation"
  });
};
QuickViewOverlay.__docgenInfo = {
  description: "",
  methods: [],
  displayName: "QuickViewOverlay"
}, QuickViewOverlay.__docgenInfo = {
  componentName: "QuickViewOverlay",
  packageName: "@jutro/quick-view",
  description: "",
  displayName: "QuickViewOverlay",
  methods: [],
  actualName: "QuickViewOverlay"
};